export default class Events {
    listeners = {};
    on(eventName, handler) {
      this.listeners[eventName] = this.listeners[eventName] || [];
      this.listeners[eventName].push(handler);
      return () => {
        this.listeners[eventName] = this.listeners[eventName].filter(
          (v) => v !== handler
        );
      };
    }
    emit(eventName, eventData) {
      if (this.listeners[eventName] && this.listeners[eventName].length > 0) {
        this.listeners[eventName].forEach((handler) => {
          handler(eventData);
        });
      }
    }
  }